import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { Observable } from "rxjs";
import { saveAs } from 'file-saver';
import { Page } from "../../../model/Paginacao/Page";
import { Lotacao } from "../../../model/lotacao";
import { PosCampanhaService } from "../../../service/posCampanha/pos-campanha.service";
import { DadosPessoaisPosRecadDto } from "./dadosPessoaisPosRecad.dto";
import { MatTableDataSource } from "@angular/material/table";
import { ServidorRecad } from "../../../model/servidorRecad";
import { ThemePalette } from "@angular/material/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ToastrService } from "ngx-toastr";


type DadosTabela = {
  descricao: string;
  informacaoSrh: string;
  informacaoRecad: string;
  anexo: string;
  check: boolean;
}

@Component({
  selector: 'app-aba1-posrecad',
  templateUrl: './aba1-posrecad.component.html',
  styleUrls: ['./aba1-posrecad.component.sass']
})
export class Aba1PosrecadComponent implements OnInit, OnDestroy, OnChanges{

  @Input() servidor: ServidorRecad;
  @Output() flExibirTab: EventEmitter<any> = new EventEmitter<any>();
  @Output() salvoOutput: EventEmitter<any> = new EventEmitter<any>();
  @Output() botoesDesabilitadosDadosPessoais: EventEmitter<any> = new EventEmitter<any>();
  @Input() btnDesativadoDadosPessoais: boolean;
  displayedColumns: string[] = ['descricao', 'antes', 'depois', 'acoes'];
  dataSource: MatTableDataSource<DadosTabela> = new MatTableDataSource<DadosTabela>([]);
  color: ThemePalette = 'primary';
  list: DadosTabela[] = [];
  isDisabledJustificativa: boolean = true
  justificativa: string = '';
  dadosPessoais: DadosPessoaisPosRecadDto;
  salvo: boolean = false;
  caracteresRestantes: number = 2000;

  constructor(private posCampanhaService: PosCampanhaService, private toasterService: ToastrService,) { }

  ngOnInit(): void {

  }

  visualizarComprovante(comprovante: string) {
    this.getVisualizarComprovante(this.servidor.recadServidorId, comprovante).subscribe(
      response => {
        const blobUrl = URL.createObjectURL(response);

        // Especifica as dimensões da nova janela (largura x altura)
        const newWindow = window.open(blobUrl, '_blank', 'width=800,height=800');

        // Verifica se a janela foi aberta com sucesso
        if (newWindow) {
          newWindow.focus();
        } else {
          this.toasterService.warning('Erro ao abrir a nova janela.', '', {
            timeOut: 1500
          });
        }
      },
      error => {
        console.log(error)
        this.toasterService.warning('Erro ao visualizar o arquivo.', '', {
          timeOut: 1500
        });
      }
    );
  }

  ngOnDestroy() {

  }

  ngOnChanges(changes: SimpleChanges) {
    this.dataSource.data = [];
    this.list = [];
    this.justificativa = "";
    this.salvo = false;
    this.findLotacao(this.servidor.id)
  }

  updateJustificativaField() {
    const atLeastOneCheckIsFalse = this.list.some(item => !item.check);
    if (atLeastOneCheckIsFalse) {
      this.isDisabledJustificativa = false
      return true

    } else {
      this.isDisabledJustificativa = true
      this.justificativa = ''
      return false
    }
  }

  findLotacao(recadServidorId: number) {
    this.getDadosPessoais(recadServidorId).subscribe(
      response => {
        if(response){
          this.dadosPessoais = response
          this.dataSource.data = this.montarDadosTabela(response);
        } else {
          this.flExibirTab.emit(false);
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  private montarDadosTabela(resp: DadosPessoaisPosRecadDto): DadosTabela[] {
    this.list.push(
      { descricao: "Estado Civil", informacaoSrh: resp.descricaoEstadoCivilSrh, anexo: "estado-civil", informacaoRecad: resp.descricaoEstadoCivilRecad, check: true },
      { descricao: "Nome Cônjuge", informacaoSrh: resp.nomeConjugeSrh, anexo: "nome-conjuge", informacaoRecad: resp.nomeConjugeRecad, check: true },
      { descricao: "Grau de Instrução", informacaoSrh: resp.descricaoGrauInstrucaoSrh, anexo: "grau-instrucao", informacaoRecad: resp.descricaoGrauInstrucaoRecad, check: true },
    )
    return this.list;
  }

  private getDadosPessoais(recadServidorId: number): Observable<DadosPessoaisPosRecadDto> {

    return this.posCampanhaService.getDadosPessoais(recadServidorId);
  }

  private getVisualizarComprovante(recadServidorId: number, comprovante: string): Observable<any> {
    return this.posCampanhaService.visualizarAnexo(recadServidorId, comprovante);
  }

  salvar() {
    /*
    status
    1- aceito
    2-pendente
    3- recusado
    4- sem alteracao
    * */
    this.botoesDesabilitadosDadosPessoais.emit(true);
    if(this.updateJustificativaField() && this.justificativa == ''){
      this.toasterService.warning('Atenção: O campo justificativa é obrigatório.');
      return
    }

    let body = {
      validacaoDadosPessoaisId: this.dadosPessoais.recadValidacaoDadosPessoaisId,
      statusGrauInstrucao: this.list[2].informacaoRecad == 'F' ? 4 : this.list[2].informacaoRecad && this.list[2].check ? 1 : 3,
      statusEstadoCivel: this.list[0].informacaoRecad == 'F' ? 4 : this.list[0].informacaoRecad && this.list[0].check ? 1 : 3,
      statusNomeConjuge: this.list[1].informacaoRecad == 'F' ? 4 : (this.list[1].informacaoRecad || this.list[1].informacaoRecad==null) && this.list[1].check ? 1 : 3,
      justificativa: this.justificativa,
      codGrauInstrucao: this.dadosPessoais.codgGrauInstrucaoRecad,
      codEstadoCivel: this.dadosPessoais.codgEstadoCivilRecad,
      nomeConjuge: this.list[1].informacaoRecad,
    }
    this.posCampanhaService.postDadosPessoais(body).subscribe( resp => {
      this.toasterService.success("Dados salvos com sucesso");
      this.salvo = true;
      this.salvoOutput.emit(true);
    });
  }
}
